import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

const fields: { label: string; field: keyof LanguageConfigModel }[] = [
  { label: "Agent Welcome Message", field: "agentWelcomeMessage" },
  { label: "Chat Closed Text", field: "chatClosedText" },
  { label: "Agent Joined Text", field: "agentJoinedText" },
  { label: "Agent Exited Text", field: "agentExitedText" },
  { label: "Typing Indicator Text", field: "typingIndicatorText" },
  { label: "Close Chat Confirm Text", field: "closeChatConfirmText" },
  { label: "Yes Button Text", field: "yesButtonText" },
  { label: "No Button Text", field: "noButtonText" }
];

export function Notices(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: { ...workingLanguageConfig, ...updates }
    });
  };

  return (
    <Accordion.Item eventKey="notices" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Notices & System Messages</Accordion.Title>
        <Accordion.SubTitle>
          Customize automated messages shown during a conversation
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="space-y-3 pb-2">
          {fields.map(({ label, field }) => (
            <div key={field}>
              <div className="text-sm font-medium mb-1">{label}</div>
              <TextInput
                value={(workingLanguageConfig[field] as string) ?? ""}
                setValue={(value) => updateLanguageConfig({ [field]: value })}
                showEmojiButton={false}
                ariaLabel={label}
              />
            </div>
          ))}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
